/**
 * ハッシュリンククリック時smooth、 headerガター調整
 * - 同一ページ内アンカー: クリックでスムーススクロール
 * - 別ページ＋ハッシュ: 遷移後 load でスムーススクロール
 * - js-section-tracker-nav など動的追加リンクは MutationObserver で拾う
 */
export default function initSmoothScroll() {
  const anchorLinksSelector = 'a[href*="#"]:not([href*="#tab-panel-"])';

  function addClickEventListener(link) {
    if (link.dataset.smoothScrollAttached) return;
    link.dataset.smoothScrollAttached = "1";
    link.addEventListener("click", (e) => {
      const hash = link.hash;
      if (!hash) return;
      const targetElm = document.querySelector(hash);
      // 同一ページにターゲットがある場合のみ preventDefault して自前でスクロール
      if (targetElm) {
        e.preventDefault();
        scrollToTarget(targetElm);
      }
    });
  }

  function scrollToTarget(targetElm, smooth = true) {
    if (!targetElm) return;
    const header = document.querySelector(".js-header-fixed");
    const fixGutter = header ? header.clientHeight : 0;
    const targetRect = targetElm.getBoundingClientRect().top;
    const targetPos = targetRect + window.scrollY - fixGutter - 30;

    window.scrollTo({
      top: Math.max(0, targetPos),
      behavior: smooth ? "smooth" : "auto",
    });
  }

  // 初期表示のアンカーリンクにリスナーを付与
  document.querySelectorAll(anchorLinksSelector).forEach(addClickEventListener);

  // アンカー付きでページ遷移した場合: load 後に DOM から取得してスクロール
  const urlHash = location.hash;
  if (urlHash) {
    window.addEventListener("load", () => {
      const targetElm = document.querySelector(urlHash);
      scrollToTarget(targetElm);
    });
  }

  // 動的追加されたリンク（js-section-tracker-nav 等）を監視
  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        if (node.matches?.(anchorLinksSelector)) addClickEventListener(node);
        node.querySelectorAll?.(anchorLinksSelector).forEach(addClickEventListener);
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
}
